import { css } from "@emotion/react";

import { uiGray, green } from "constants/colors";

import { FieldLabel } from "../shared/library/FieldLabel";

const style = {
  wrapper: css({
    gap: 16,
    display: "flex",
    width: "100%",
  }),
  squareWrapper: css({
    gap: 8,
    display: "flex",
    flex: 1,
  }),
  square: css({
    flex: 1,
    background: uiGray[10],
    height: 20,
    borderRadius: 4,
  }),
  filled: css({
    width: "100%",
    background: green[800],
  }),
};

type Props = { volumeInDb: number };
export const AudioInputLevel = ({ volumeInDb }: Props) => {
  // This component assumes an audio level between -40 and 0 dB
  const volumeScale = (((volumeInDb || -40) + 40) * 8) / 40;
  return (
    <div css={style.wrapper}>
      <FieldLabel label={"Input level"} />
      <div css={style.squareWrapper}>
        {[0, 1, 2, 3, 4, 5, 6, 7].map((item) => (
          <div
            key={item}
            data-testid={`audio-input-level-square-${item}`}
            css={[style.square, volumeScale > item ? style.filled : undefined]}
          ></div>
        ))}
      </div>
    </div>
  );
};
